// @ts-nocheck
import * as React from "react";

const Facebook: React.FC = () => {
    return (
        <svg focusable="false" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24">
            <path
                fillRule="evenodd"
                clipRule="evenodd"
                fill="currentColor"
                d="M13.821 22v-9h2.733L17 9h-3.179V7.052c0-1.03.027-2.052 1.466-2.052h1.458V2.14c0-.043-1.253-.14-2.52-.14-2.645 0-4.302 1.657-4.302 4.7V9H7v4h2.923v9h3.898z"
            />
        </svg>
    );
};

export default React.memo(Facebook);
